export default "__VITE_ASSET__KEs6qyb4__"